<div class="slideout-content">
  <!-- Modal to add new user starts-->
  <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
    <div class="modal-dialog" 
    [ngStyle]="
    isSmallDisplay?{'width': '26rem'} : {'width': '60%'}"
    >
      <form class="add-new-user modal-content pt-0" (ngSubmit)="(editTemplateForm.form.valid)" #editTemplateForm="ngForm">
        <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="toggleSidebar('template-sidebar')"
        >
          ×
        </button>
        <div class="modal-header mb-1">
          <h5 class="modal-title" id="exampleModalLabel" *ngIf="currentTemplate.id != null">Edit Payment Plan</h5>
          <h5 class="modal-title" id="exampleModalLabel" *ngIf="currentTemplate.id == null">New Payment Plan</h5>
        </div>

        <div class="modal-body flex-grow-1">
          
          <div class="row">
            <!-- Name -->
            <div class="form-group col-6">
              <label class="form-label" for="template-sidebar-name"
                >Name</label
              >
              <input
                type="text"
                class="form-control"
                id="template-sidebar-name"
                placeholder="My Payment Plan Name"
                name="template-sidebar-name"
                [(ngModel)]="currentTemplate.title"
                [class.error]="editTemplateForm.submitted && FNameRef.invalid"
                tabindex="1" 
                #FNameRef="ngModel"
                required
              />
              <span
                *ngIf="editTemplateForm.submitted && FNameRef.invalid"
                class="invalid-form"
              >
                <small
                  class="form-text text-danger"
                  *ngIf="FNameRef.errors.required"
                  >This field is required!</small
                >
              </span>
            </div>
            <!--/ Name -->

            <!-- Locations -->
            <div class="form-group col-6">
              <label>Locations</label>
              <ng-select
                [items]="locations"
                [multiple]="true"
                bindLabel="name"
                bindValue="id"
                tabindex="2" 
                [closeOnSelect]="false"
                name="template-sidebar-locations"
                [(ngModel)]="currentTemplate.location_id"
                #FLocationRef="ngModel"

              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span class="ng-value-label">
                    <img *ngIf="item.locationLogo == ''" src="../../../../../assets/images/profile/user-uploads/location-00.png" width="20px" height="20px" /> 
                    <img *ngIf="item.locationLogo != ''" [src]="item.locationLogo" width="20px" height="20px" />
                    {{ item.locationName }}</span
                  >
                  <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                </ng-template>
  
                <ng-template ng-header-tmp>
                  <a
                    (click)="selectAll()"
                    class="btn btn-flat-primary btn-sm"
                  >
                    Select all
                  </a>
                  <a
                    (click)="unselectAll()"
                    class="btn btn-flat-primary btn-sm"
                  >
                    Unselect all
                 </a>
                </ng-template>
  
                <ng-template ng-option-tmp let-item="item">
                  <img *ngIf="item.locationLogo == ''" src="../../../../../assets/images/profile/user-uploads/location-00.png" width="20px" height="20px" /> 
                  <img *ngIf="item.locationLogo != ''" [src]="item.locationLogo" width="20px" height="20px" />
  
                  {{ item.locationName }}
                </ng-template>
              </ng-select>
            </div>
            <!--/ Locations -->

            <div class="col-12">
              <!-- Description -->
              <div class="form-group">
                <label class="form-label" for="template-sidebar-description">Description</label>
                <fieldset class="form-label-group mb-0">
                  <textarea
                    [(ngModel)]="currentTemplate.description"
                    name="template-sidebar-description"
                    [maxlength]="200"
                    class="form-control dt-description"
                    placeholder="Plan description"
                    id="template-sidebar-description"
                    rows="3"
                    tabindex="3" 
                    #FDescriptionRef="ngModel"
                    required

                  ></textarea>
                  <span *ngIf="editTemplateForm.submitted && FDescriptionRef.invalid" class="invalid-form">
                    <small class="form-text text-danger" *ngIf="FDescriptionRef.errors.required">This field is required!</small>
                  </span>
                </fieldset>
                <small class="textarea-counter-value float-right"
                  ><span *ngIf="FDescriptionRef" class="char-count">{{ FDescriptionRef.value.length }}</span>
                  <span *ngIf="!FDescriptionRef" class="char-count">0 </span> / 200
                </small>
              </div>  
              <!--/ Description -->
              
              <!-- Only for Members -->
              <div class="form-group">
                  <div class="custom-control custom-switch custom-switch" >
                    <h6>Only for Members:
  
                      <input 
                        type="checkbox" 
                        class="custom-control-input" 
                        id="template-sidebar-onlyMembers" 
                        [checked]="currentTemplate.settings.limits.onlyMembers" 
                        [(ngModel)]="currentTemplate.settings.limits.onlyMembers" 
                        name="template-sidebar-onlyMembers"
                        #FOnlyMembersRef="ngModel"
                      />
                      <label class="custom-control-label" for="template-sidebar-onlyMembers">
                        <span class="switch-icon-left"><i data-feather="check"></i></span>
                        <span class="switch-icon-right"><i data-feather="x"></i></span>
                      </label>
                    </h6>
                  </div>
  
              </div>
              <!--/ Only for Members -->
            </div>

            <div class="col-lg-5 col-md-5 col-sm-12">

              <!-- Total Payment Amount -->
              <div class="form-group mt-2">
                <h5>Total Payment Amount</h5>
                <div class="inline-group">
                  <label for="template-sidebar-min">Minimum:</label>
                  <input
                    type="number"
                    class="form-control"
                    id="template-sidebar-min"
                    placeholder="10"
                    min="10"
                    max="100000"
                    tabindex="4" 
                    name="template-sidebar-min"
                    [(ngModel)]="currentTemplate.settings.limits.amount.min"
                    [class.error]="editTemplateForm.submitted && FMinRef.invalid"
                    #FMinRef="ngModel"
                    required
                  />
                  
                </div>
                <span
                  *ngIf="editTemplateForm.submitted && FMinRef.invalid"
                  class="invalid-form"
                >
                  <small
                    class="form-text text-danger"
                    *ngIf="FMinRef.errors.required"
                    >This field is required!</small
                  >
                  <small
                    class="form-text text-danger"
                    *ngIf="!FMinRef.errors.required"
                    >This value is not valid!</small
                  >
                </span>

                <div class="inline-group">
                  <label for="template-sidebar-min">Maximum:</label>
                  <input
                    type="number"
                    class="form-control"
                    id="template-sidebar-max"
                    placeholder="100000"
                    name="template-sidebar-max"
                    min="10"
                    max="100000"
                    tabindex="5" 
                    [(ngModel)]="currentTemplate.settings.limits.amount.max"
                    [class.error]="editTemplateForm.submitted && FMaxRef.invalid"
                    #FMaxRef="ngModel"
                    required
                  />
                </div>
                <span
                  *ngIf="editTemplateForm.submitted && FMaxRef.invalid"
                  class="invalid-form"
                >
                  <small
                    class="form-text text-danger"
                    *ngIf="FMaxRef.errors.required"
                    >This field is required!</small
                  >
                  <small
                    class="form-text text-danger"
                    *ngIf="!FMaxRef.errors.required"
                    >This value is not valid!</small
                  >
                </span>

              </div>
              <!--/ Total Payment Amount -->
              
              <!-- Months Limit -->
              <div class="form-group mt-2">
                <h5>
                  Instalment length (month):
                </h5>
                <div *ngIf="currentTemplate.content.instalmentTimes==null; else hasInstalmentTimes">
                  <button type="button" tabindex="4" (click)="switchOption('hasInstalmentTimes')" class="btn btn-outline-secondary" rippleEffect>
                    ADD +
                  </button>                      
                </div>
                <ng-template #hasInstalmentTimes>
                  <div class="row">
                    <div class="inline-group col-7" >
                      <label for="template-sidebar-instalmentTimes">Default:</label>
                      <input
                        type="number"
                        class="form-control"
                        id="template-sidebar-instalmentTimes"
                        placeholder="1"
                        min="1"
                        max="60"
                        tabindex="4" 
                        name="template-sidebar-instalmentTimes"
                        [(ngModel)]="currentTemplate.content.instalmentTimes"
                        [class.error]="editTemplateForm.submitted && FInstalmentTimesRef.invalid"
                        #FInstalmentTimesRef="ngModel"
                        required
                      />
                      
                    </div>
                    <div class="col-5" style="text-align-last: center;">
                      <div class="custom-control custom-switch custom-switch">
                        <input 
                          type="checkbox" 
                          class="custom-control-input" 
                          id="edit-template-sidebar-editableSwitchInstalmentTimes" 
                          [checked]="currentTemplate.settings.editable.instalmentTimes" 
                          (click)="switchEditable('instalmentTimes')" 
                          name="template-sidebar-editableSwitchInstalmentTimes"
                          [(ngModel)]="currentTemplate.settings.editable.instalmentTimes"
                          #FSwitchInstalmentTimesRef="ngModel"
                          />
                        <label class="custom-control-label" for="edit-template-sidebar-editableSwitchInstalmentTimes">
                          <span class="switch-icon-left"><i data-feather="check"></i></span>
                          <span class="switch-icon-right"><i data-feather="x"></i></span>
                        </label>
                      </div>
                      <label>Editable</label>
                    </div>  
                    <div class="inline-group col-7" *ngIf="currentTemplate.settings.editable.instalmentTimes">
                      <label for="template-sidebar-monthsLimit">Maximum:</label>
                      <input
                        type="number"
                        class="form-control"
                        id="template-sidebar-monthsLimit"
                        placeholder="0"
                        min="1"
                        max="60"
                        tabindex="4" 
                        name="template-sidebar-monthsLimit"
                        [(ngModel)]="currentTemplate.settings.limits.monthsLimit"
                        [class.error]="editTemplateForm.submitted && FMonthsLimitRef.invalid"
                        #FMonthsLimitRef="ngModel"
                        required
                      />
                      
                    </div>
                    <span
                      *ngIf="editTemplateForm.submitted && FSwitchInstalmentTimesRef.invalid"
                      class="invalid-form"
                    >
                      <small
                        class="form-text text-danger"
                        *ngIf="FSwitchInstalmentTimesRef.errors.required"
                        >This field is required!</small
                      >
                      <small
                        class="form-text text-danger"
                        *ngIf="!FSwitchInstalmentTimesRef.errors.required"
                        >This limit is not valid!</small
                      >
                    </span>

                  </div>
                </ng-template>
              </div>
              <!--/ Months Limit -->

              <!-- Start Date -->
              <div class="form-group mt-2">
                <h5>
                  Set instalment to start after:
                </h5>
                <div *ngIf="currentTemplate.content.start_at==null; else hasContentStartAt">
                  <button type="button" tabindex="4" (click)="switchOption('hasContentStartAt')" class="btn btn-outline-secondary" rippleEffect>
                    ADD +
                  </button>                      
                </div>
                <ng-template #hasContentStartAt>
                  <div class="row">
                    <div class="inline-group col-7">
                      <label for="template-sidebar-contentStartAt">Days:</label>
                      <input
                        type="number"
                        class="form-control"
                        id="template-sidebar-contentStartAt"
                        placeholder="0"
                        min="0"
                        max="120"
                        tabindex="4" 
                        name="template-sidebar-contentStartAt"
                        [(ngModel)]="currentTemplate.content.start_at"
                        [class.error]="editTemplateForm.submitted && FContentStartAtRef.invalid"
                        #FContentStartAtRef="ngModel"
                        required
                      />
                      
                    </div>
                    <div class="col-5" style="text-align-last: center;">
                      <div class="custom-control custom-switch custom-switch">
                        <input 
                          type="checkbox" 
                          class="custom-control-input" 
                          id="edit-template-sidebar-editableSwitchContentStartAt" 
                          [checked]="currentTemplate.settings.editable.start_at" 
                          (click)="switchEditable('start_at')" 
                          name="template-sidebar-editableSwitchContentStartAt"
                          [(ngModel)]="currentTemplate.settings.editable.start_at"
                          #FEditableSwitchContentStartAtRef="ngModel"
                          />
                        <label class="custom-control-label" for="edit-template-sidebar-editableSwitchContentStartAt">
                          <span class="switch-icon-left"><i data-feather="check"></i></span>
                          <span class="switch-icon-right"><i data-feather="x"></i></span>
                        </label>
                      </div>
                      <label>Editable</label>
                    </div>  
                    <span
                      *ngIf="editTemplateForm.submitted && FEditableSwitchContentStartAtRef.invalid"
                      class="invalid-form"
                    >
                      <small
                        class="form-text text-danger"
                        *ngIf="FEditableSwitchContentStartAtRef.errors.required"
                        >This field is required!</small
                      >
                      <small
                        class="form-text text-danger"
                        *ngIf="!FEditableSwitchContentStartAtRef.errors.required"
                        >This limit is not valid!</small
                      >
                    </span>
  
                  </div>
                </ng-template>

              </div>
              <!--/ Months Limit -->
            </div>

            <div class="col-lg-7 col-md-7 col-sm-12 mt-2">
              <!-- Payment Frequency -->
              <div class="form-group">
                <h5>
                  Payment Frequency:
                </h5>
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12" style="text-align-last: center;">
                    <div class="custom-control custom-switch custom-switch">
                      <input 
                        type="checkbox" 
                        class="custom-control-input" 
                        id="edit-template-sidebar-frequencySwitchWeekly" 
                        [checked]="currentTemplate.settings.frequency.weekly" 
                        (click)="switchFrequency('weekly')" 
                        name="template-sidebar-weekly"
                        [(ngModel)]="currentTemplate.settings.frequency.weekly"
                        #FWeeklyRef="ngModel"
    
                      />
                      <label class="custom-control-label" for="edit-template-sidebar-frequencySwitchWeekly">
                        <span class="switch-icon-left"><i data-feather="check"></i></span>
                        <span class="switch-icon-right"><i data-feather="x"></i></span>
                      </label>
                    </div>
                    <label>Weekly</label>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12" style="text-align-last: center;">
                    <div class="custom-control custom-switch custom-switch" >
                      <input 
                        type="checkbox" 
                        class="custom-control-input" 
                        id="edit-template-sidebar-frequencySwitchFortnightly" 
                        [checked]="currentTemplate.settings.frequency.fortnightly" 
                        (click)="switchFrequency('fortnightly')"
                        name="template-sidebar-fortnightly"
                        [(ngModel)]="currentTemplate.settings.frequency.fortnightly"
                        #FFortnightlyRef="ngModel"
    
                        />
                      <label class="custom-control-label" for="edit-template-sidebar-frequencySwitchFortnightly">
                        <span class="switch-icon-left"><i data-feather="check"></i></span>
                        <span class="switch-icon-right"><i data-feather="x"></i></span>
                      </label>
                    </div>
                    <label>Fortnightly</label>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12" style="text-align-last: center;">
                    <div class="custom-control custom-switch custom-switch" >
                      <input 
                        type="checkbox" 
                        class="custom-control-input" 
                        id="edit-template-sidebar-frequencySwitchfrequencySwitchMonthly" 
                        [checked]="currentTemplate.settings.frequency.monthly" 
                        (click)="switchFrequency('monthly')"
                        name="template-sidebar-monthly"
                        [(ngModel)]="currentTemplate.settings.frequency.monthly"
                        #FMonthlyRef="ngModel"
                        />
                      <label class="custom-control-label" for="edit-template-sidebar-frequencySwitchMonthly">
                        <span class="switch-icon-left"><i data-feather="check"></i></span>
                        <span class="switch-icon-right"><i data-feather="x"></i></span>
                      </label>
                    </div>
                    <label>Monthly</label>
                  </div>
                </div>
              </div>
              <!--/ Payment Frequency -->
              
              <!-- Amount -->
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-12">
                    <h6>Amount</h6>
                  </div>
                  <div *ngIf="currentTemplate.content.amount==null; else hasAmount">
                    <button type="button" tabindex="4" (click)="switchOption('hasAmount')" class="btn btn-outline-secondary" rippleEffect>
                      ADD +
                    </button>                      
                  </div>
                  <ng-template #hasAmount>
                    <div class="col-6">
                      <input [(ngModel)]="currentTemplate.content.amount"
                        id="payment_amount"
                        name="template-sidebar-amount"
                        class="form-control"
                        type="number"
                        [max]="currentTemplate.settings.limits.amount.max"
                        [min]="0"
                        placeholder="$0.00"
                        step="0.01"
                        tabindex="6" 
                      />
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-2" style="text-align-last: center;">
                      <div class="custom-control custom-switch custom-switch">
                        <input 
                          type="checkbox" 
                          class="custom-control-input" 
                          id="edit-template-sidebar-editableSwitchAmount" 
                          [checked]="currentTemplate.settings.editable.amount" 
                          (click)="switchEditable('amount')" 
                          name="template-sidebar-editableSwitchAmount"
                          [(ngModel)]="currentTemplate.settings.editable.amount"
                          #FSwitchAmountRef="ngModel"
                          />
                        <label class="custom-control-label" for="edit-template-sidebar-editableSwitchAmount">
                          <span class="switch-icon-left"><i data-feather="check"></i></span>
                          <span class="switch-icon-right"><i data-feather="x"></i></span>
                        </label>
                      </div>
                      <label>Editable</label>
                    </div>  
                  </ng-template>
                </div>
              </div>
              <!--/ Amount -->

              <!-- Setup Fee -->
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-12">
                    <h6>Setup Fee</h6>
                  </div>
                  <div *ngIf="currentTemplate.content.setupFee==null; else hasSetupFee">
                    <button type="button" tabindex="4" (click)="switchOption('hasSetupFee')" class="btn btn-outline-secondary" rippleEffect>
                      ADD +
                    </button>                      
                  </div>
                  <ng-template #hasSetupFee>
                    <div class="col-lg-3 col-md-3 col-sm-4" style="text-align-last: center;">
                      <input [(ngModel)]="currentTemplate.content.setupFee" name="template-sidebar-setupFee" class="form-control" type="number" placeholder="0,00" tabindex="7" />
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-4" style="text-align-last: center;">
                      <button 
                        type="button" 
                        id="setupFeeDollarOption" 
                        style="margin-right: 5px;" 
                        (click)="switchDollarPercent('setupFee')" 
                        class="btn btn-icon rounded-circle"
                        [ngClass]="currentTemplate.content.setupFeeCash ? 'btn-primary' : 'btn-outline-secondary'"
                        name="template-sidebar-setupFeeCash"
                        [(ngModel)]="currentTemplate.content.setupFeeCash"
                        #FSetupFeeCashRef="ngModel"
                        rippleEffect>
                        <span [data-feather]="'dollar-sign'"></span>
                      </button>
                      <button 
                        type="button" 
                        id="setupFeePercentOption" 
                        (click)="switchDollarPercent('setupFee')" 
                        class="btn btn-icon btn-icon rounded-circle" 
                        [ngClass]="!currentTemplate.content.setupFeeCash ? 'btn-primary' : 'btn-outline-secondary'"
                        rippleEffect>
                        <span [data-feather]="'percent'"></span>
                        </button>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-2" style="text-align-last: center;">
                      <div class="custom-control custom-switch custom-switch">
                        <input 
                          type="checkbox" 
                          class="custom-control-input" 
                          id="edit-template-sidebar-editableSwitchSetupFee" 
                          [checked]="currentTemplate.settings.editable.setupFee" 
                          (click)="switchEditable('setupFee')" 
                          name="template-sidebar-editableSwitchSetupFee"
                          [(ngModel)]="currentTemplate.settings.editable.setupFee"
                          #FSwitchSetupFeeRef="ngModel"
                          />
                        <label class="custom-control-label" for="edit-template-sidebar-editableSwitchSetupFee">
                          <span class="switch-icon-left"><i data-feather="check"></i></span>
                          <span class="switch-icon-right"><i data-feather="x"></i></span>
                        </label>
                      </div>
                      <label>Editable</label>
                    </div>   
                  </ng-template>            
                </div>
              </div>      
                <!--/ Setup Fee -->

              <!-- Deposit -->
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-12">
                    <h6>Deposit</h6>
                  </div>
                  <div *ngIf="currentTemplate.content.deposit==null; else hasDeposit">
                    <button type="button" tabindex="4" (click)="switchOption('hasDeposit')" class="btn btn-outline-secondary" rippleEffect>
                      ADD +
                    </button>                      
                  </div>
                  <ng-template #hasDeposit>
                    <div class="col-lg-3 col-md-3 col-sm-4" style="text-align-last: center;">
                      <input [(ngModel)]="currentTemplate.content.deposit" name="template-sidebar-deposit" class="form-control" type="number" placeholder="0,00" tabindex="8" />
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-4" style="text-align-last: center;">
                      <button 
                        type="button" 
                        id="depositDollarOption" 
                        style="margin-right: 5px;" 
                        (click)="switchDollarPercent('deposit')"
                        class="btn btn-icon rounded-circle" 
                        [ngClass]="currentTemplate.content.depositCash ? 'btn-primary' : 'btn-outline-secondary'"
                        rippleEffect>
                        <span [data-feather]="'dollar-sign'"></span>
                      </button>
                      <button 
                        type="button" 
                        id="depositPercentOption" 
                        (click)="switchDollarPercent('deposit')" 
                        class="btn btn-icon btn-icon rounded-circle" 
                        [ngClass]="!currentTemplate.content.depositCash ? 'btn-primary' : 'btn-outline-secondary'"
                        name="template-sidebar-depositCash"
                        [(ngModel)]="currentTemplate.content.depositCash"
                        #FDepositCashRef="ngModel"
                        rippleEffect>
                        <span [data-feather]="'percent'"></span>
                      </button>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-2" style="text-align-last: center;">
                      <div class="custom-control custom-switch custom-switch">
                        <input 
                          type="checkbox" 
                          class="custom-control-input" 
                          id="edit-template-sidebar-editableSwitchDeposit" 
                          [checked]="currentTemplate.settings.editable.deposit" 
                          (click)="switchEditable('deposit')" 
                          name="template-sidebar-editableSwitchDeposit"
                          [(ngModel)]="currentTemplate.settings.editable.deposit"
                          #FSwitchDepositRef="ngModel"
                          />
                        <label class="custom-control-label" for="edit-template-sidebar-editableSwitchDeposit">
                          <span class="switch-icon-left"><i data-feather="check"></i></span>
                          <span class="switch-icon-right"><i data-feather="x"></i></span>
                        </label>
                      </div>
                      <label>Editable</label>
                    </div>    
                  </ng-template>           
                </div>
              </div>      
              <!--/ Deposit -->

              <!-- Admin Fee -->
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-12">
                    <h6>Admin Fee</h6>
                  </div>
                  <div *ngIf="currentTemplate.content.adminFee==null; else hasAdminFee">
                    <button type="button" tabindex="4" (click)="switchOption('hasAdminFee')" class="btn btn-outline-secondary" rippleEffect>
                      ADD +
                    </button>                      
                  </div>
                  <ng-template #hasAdminFee>
                    <div class="col-lg-3 col-md-3 col-sm-4" style="text-align-last: center;">
                      <input [(ngModel)]="currentTemplate.content.adminFee" name="template-sidebar-adminFee" class="form-control" type="number" placeholder="0,00" tabindex="9" />
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-4" style="text-align-last: center;">
                      <button 
                        type="button" 
                        id="adminFeeDollarOption" 
                        style="margin-right: 5px;" 
                        (click)="switchDollarPercent('adminFee')" 
                        class="btn btn-icon rounded-circle"  
                        [ngClass]="currentTemplate.content.adminFeeCash ? 'btn-primary' : 'btn-outline-secondary'"
                        name="template-sidebar-adminFeeCash"
                        [(ngModel)]="currentTemplate.content.adminFeeCash"
                        #FAdminFeeCashRef="ngModel"
                        rippleEffect>
                        <span [data-feather]="'dollar-sign'"></span>
                      </button>
                      <button 
                        type="button" 
                        id="adminFeePercentOption" 
                        (click)="switchDollarPercent('adminFee')" 
                        class="btn btn-icon btn-icon rounded-circle" 
                        [ngClass]="!currentTemplate.content.adminFeeCash ? 'btn-primary' : 'btn-outline-secondary'"
                        rippleEffect>
                        <span [data-feather]="'percent'"></span>
                        </button>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-2" style="text-align-last: center;">
                      <div class="custom-control custom-switch custom-switch">
                        <input 
                          type="checkbox" 
                          class="custom-control-input" 
                          id="edit-template-sidebar-editableSwitchAdminFee" 
                          [checked]="currentTemplate.settings.editable.adminFee" 
                          (click)="switchEditable('adminFee')" 
                          name="template-sidebar-editableSwitchAdminFee"
                          [(ngModel)]="currentTemplate.settings.editable.adminFee"
                          #FSwitchAdminFeeRef="ngModel"
                          />
                        <label class="custom-control-label" for="edit-template-sidebar-editableSwitchAdminFee">
                          <span class="switch-icon-left"><i data-feather="check"></i></span>
                          <span class="switch-icon-right"><i data-feather="x"></i></span>
                        </label>                    </div>
                      <label>Editable</label>

                    </div>          
                  </ng-template>     
                </div>
              </div>      
              <!--/ Admin Fee -->
            </div>

          </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-between" *ngIf="!loadingButton">
            <button type="button" class="btn btn-icon btn-icon rounded-circle btn-danger" style="position:absolute; left :15px;" (click)="modalOpenDeleteItem(modalDeleteTemplate)" [disabled]="loadingButton" rippleEffect>
              <span [data-feather]="'trash-2'"></span></button
            >    
            <button type="submit" class="btn btn-primary mr-1" tabindex="10" *ngIf="currentTemplate.id == null" (click)="submit(editTemplateForm, 'new')" [disabled]="loadingButton" rippleEffect>
              <span *ngIf="loadingButton" class="spinner-border spinner-border-sm mr-1"></span>
              Submit</button>
            <button type="submit" class="btn btn-primary mr-1" tabindex="10" *ngIf="currentTemplate.id != null" (click)="submit(editTemplateForm, 'update')" [disabled]="loadingButton" rippleEffect>
              <span *ngIf="loadingButton" class="spinner-border spinner-border-sm mr-1"></span>
              Save Changes</button>
            <button
              type="reset"
              class="btn btn-outline-secondary"
              tabindex="11"
              (click)="toggleSidebar('template-sidebar')"
              [disabled]="loadingButton"
              rippleEffect
              >
              <span *ngIf="loadingButton" class="spinner-border spinner-border-sm mr-1"></span>
              Cancel
            </button>

          </div>
        </div>      
      </form>
    </div>
  </div>
  <!-- Modal to add new user Ends-->
</div>


<!-- Modal Delete Item -->
<ng-template #modalDeleteTemplate let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel4">Delete</h4>
  </div>
  <div class="modal-body">
    <p>Do you really want to delete it permanently?</p>
  </div>
  <div class="modal-footer">

      <button type="button" class="btn btn-success" (click)="deleteItem()" [disabled]="loadingButton"
        rippleEffect>
        <span *ngIf="loadingButton" class="spinner-border spinner-border-sm mr-1"></span>
        <span>YES</span></button
      >        

      <button type="button" class="btn btn-danger" (click)="modal.close('Accept click')" [disabled]="loadingButton" rippleEffect>
        <span *ngIf="loadingButton" class="spinner-border spinner-border-sm mr-1"></span>
        <span>NO</span></button
      >
  </div>
</ng-template>
<!-- / Modal Delete Item -->

